import React from "react";
import { getTopiclists } from "../../helpers/backend_helper";
import CodeList from "../Standards/CodeList";
import TopicDetail from "./TopicDetail";

const TopicList = ({ createRequest = 0 }) => (
  <CodeList
    createRequest={createRequest}
    listCodes={() => getTopiclists(true)}
    DetailComponent={TopicDetail}
    codeLabel="Checklist Topic"
    codesLabel="Checklist Topics"
    categoryLabel="Checklist Configuration"
    searchPlaceholder="Search checklist topics..."
    fileName="checklist-topics"
  />
);

export default TopicList;
